import React, { useEffect, useState } from "react";
import CONSTANT from "../../../constants/Constant";
import {toast} from "react-toastify";
import './InputBox.scss';

const InputBox = ({ label, value, placeHolder, disabled= false, question, error, onChange }) => {
    const [inputValue, setInputValue] = useState('');
    const [heightInFeet, setHeightInFeet] = useState('');
    const [heightInInch, setHeightInInch] = useState('');

    useEffect(() => {
        setInputValue(value);
        if (value !== '') {
            const feet = Math.floor(value / 12);
            const inch = value % 12;
            setHeightInFeet(feet.toString());
            setHeightInInch((prevInch) => {
                if (inch === 0 && prevInch === '') {
                    return '';
                }
                return inch.toString();
            });
        }
    }, [value])

    const onChangeInput = (value, willSave = false) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        setInputValue(value);
        onChange && onChange({ question: question, answerText: value, willSave });
    };

    const onBlurInput = (value) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        setInputValue(value);
        onChange({ question: question, answerText: value });
    }

    const getAndSaveHeight = (value, type) => {
        if(disabled) {
            toast.error("Report already ready can not change the response");
            return;
        }

        let feet = 0;
        let inch = 0;
        let totalHeight;
        if (type === CONSTANT.HEIGHT.FEET) {
            if (value !== '' && !/^\d+$/.test(value)) return;
            feet = (value && parseInt(value)) || 0;
            setHeightInFeet(value);
            inch = (heightInInch && parseInt(heightInInch)) || 0;
            totalHeight = (feet * 12 + inch).toString();
        } else if (type === CONSTANT.HEIGHT.INCH) {
            if (value !== '' && !/^\d+$/.test(value)) return;
            inch = (value && parseInt(value)) || 0;
            if(inch > 11) {
                return;
            }

            const newValue = value === '' ? '' : inch.toString();
            setHeightInInch(newValue);
            feet = (heightInFeet && parseInt(heightInFeet)) || 0;
            totalHeight = (inch + feet * 12).toString();
        }

        setInputValue(totalHeight);
        onChangeInput(totalHeight, true);
    }

    return (
        <>
            {question.questionId !== CONSTANT.CHATBOT_ACCOUNT.HEIGHT && (
                <div className="inputbox__group inputbox__group--row">
                    <label id={`cc-question-${question.questionId}`}
                           className="inputbox__col-form-label inputbox__label inputbox__label--horizontal inputbox__heading-primary">{label}</label>
                    <div className="inputbox__col-xl-8 inputbox__col-lg-8">
                        <input className="inputbox__text-input" onChange={(e) => onChangeInput(e.target.value)}
                               onBlur={(e) => onBlurInput(e.target.value)}
                               placeholder={placeHolder} type="text"
                               value={inputValue} disabled={disabled}/>
                        {error && error.questionId === question.questionId && (
                            <span className="inputbox__text-muted inputbox__font-danger">* {error.message}</span>
                        )}
                    </div>
                </div>
            )}
            {question.questionId === CONSTANT.CHATBOT_ACCOUNT.HEIGHT && (
                <div className="inputbox__group inputbox__group--row">
                    <label id={`cc-question-${question.questionId}`} className="inputbox__col-form-label inputbox__label inputbox__label--horizontal inputbox__heading-primary">{label}</label>
                    <div className="inputbox__col-xl-8 inputbox__col-lg-8 inputbox__col-form-label">
                        <div className="inputbox__d-flex inputbox__space-between">
                            <input className="inputbox__text-input inputbox__text-input--w-25"
                                   onChange={(e) => getAndSaveHeight(e.target.value, CONSTANT.HEIGHT.FEET)}
                                   placeholder='Feet'
                                   maxLength="1"
                                   type="text"
                                   value={heightInFeet > 0 ? heightInFeet : ''}
                                   disabled={disabled}
                            />
                            <input className="inputbox__text-input inputbox__text-input--w-25"
                                   onChange={(e) => getAndSaveHeight(e.target.value, CONSTANT.HEIGHT.INCH)}
                                   placeholder='Inch'
                                   type="text"
                                   value={heightInInch}
                                   disabled={disabled}
                            />
                            <input className="inputbox__text-input inputbox__text-input--w-44" onChange={(e) => onChangeInput(e.target.value)}
                                   type="text"
                                   placeholder='Total height in inch'
                                   value={inputValue} disabled/>
                        </div>
                        {error && error.questionId === question.questionId && (
                            <span className="inputbox__text-muted inputbox__font-danger">* {error.message}</span>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default InputBox;
